"use client";

import { useMediaQuery } from "@/hooks/useMediaQuery";
import CustomSheet from "@/components/CustomSheet";
import { CustomDialog } from "@/components/CustomDialog";

type CustomModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  description?: string;
  children: React.ReactNode;
  headerStart?: React.ReactNode;
  contentClassName?: string;
  sheetClassName?: string;
  bodyClassName?: string;
  hideHeader?: boolean;
  hideDivider?: boolean;
  hideCloseButton?: boolean;
};

const CustomModal = ({
  open,
  onOpenChange,
  title,
  description,
  children,
  headerStart,
  contentClassName,
  sheetClassName,
  bodyClassName,
  hideHeader,
  hideDivider,
  hideCloseButton,
}: CustomModalProps) => {
  const isMobile = useMediaQuery("(max-width: 767px)");
  const scrollClassName = bodyClassName ?? "tovtrip-scrollbar";

  if (typeof window === "undefined") return null;

  if (isMobile) {
    return (
      <CustomSheet
        open={open}
        onOpenChange={onOpenChange}
        title={title ?? ""}
        description={description}
        headerStart={headerStart}
        className={sheetClassName}
        bodyClassName={scrollClassName}
        hideHeader={hideHeader}
      >
        {children}
      </CustomSheet>
    );
  }

  return (
    <CustomDialog
      hideHeader={hideHeader}
      hideDivider={hideDivider}
      open={open}
      onOpenChange={onOpenChange}
      title={title ?? ""}
      desc={description}
      headerStart={headerStart}
      contentClassName={contentClassName}
      bodyClassName={scrollClassName}
      hideCloseButton={hideCloseButton}
    >
      {children}
    </CustomDialog>
  );
};

export default CustomModal;
